import Button from '@/components/base/button/button';
import Input from '@/components/base/form/input/input';
import PhosphorIcon from '@/components/base/icon/phosphor-icon';
import { MagnifyingGlass, X } from '@phosphor-icons/react';
import { clsx } from 'clsx';
import { useTranslations } from 'next-intl';
import type { ChangeEvent } from 'react';

interface Props {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur: (e: ChangeEvent<HTMLInputElement>) => void;
  onFocus?: () => void;
  onReset: () => void;
  value: string;
  autoFocus?: boolean;
  className?: string;
  iconClassName?: string;
}

export const SearchInput = ({
  onBlur,
  onChange,
  value,
  onReset,
  autoFocus,
  className,
  iconClassName,
  onFocus,
  ...props
}: Props) => {
  const t = useTranslations('common');
  const tn = useTranslations('navigation.search');

  return (
    <Input
      className={clsx('w-full', className)}
      autoFocus={autoFocus}
      value={value}
      onBlur={onBlur}
      onChange={onChange}
      aria-label={tn('search_products')}
      onFocus={onFocus}
      {...props}
      append={
        <Button
          variant="tertiary-no-frame"
          className={clsx(
            'h-clickable-minimum w-clickable-minimum justify-self-end only:mr-0 only:ml-auto',
            value.length >= 1 ? 'block' : 'hidden',
            iconClassName,
          )}
          onClick={onReset}
        >
          <PhosphorIcon
            Icon={X}
            variant="regular"
            className="icon-m s:icon-l"
          />
          <span className="sr-only">{t('close')}</span>
        </Button>
      }
      prepend={
        <PhosphorIcon
          Icon={MagnifyingGlass}
          variant="regular"
          className="icon-m min-w-icon-medium text-muted"
        />
      }
    />
  );
};
